module.exports = __webpack_public_path__ + "img/xiaodaka.f368731f.png";